import { get } from 'lodash';

import APIUtils from './APIUtils';

class AuthAPI {
    static authorize() {
        return APIUtils.POST('/api/auth', {})
            .then(response => {
                APIUtils.saveUserInfomation(response.data);
                APIUtils.saveEnableFeatures(get(response, 'data.enable_features', {}));
                return response.data;
            }).catch(() => {
                APIUtils.logOut();
            });
    }

    static getSideBar() {
        return APIUtils.POST('/api/navigation', {})
            .then(response => {
                let result = response.data;
                return result;
            });
    }

    static getPermissions() {
        return APIUtils.POST('/api/self_permission')
            .then(response => response.data);
    }
}

export default AuthAPI;
